export default __webpack_public_path__ + "assets/landing-page-1.jpg";